import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/logo.png'


const _hoisted_1 = { class: "site-logo" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { ref, defineComponent } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const top = ref(0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})